/**
 * Adds a MutationObserver to hostElements to be able to react to slot content changes.
 * This is especially helpful for complex component structures which need to be reinitialized if the slot content changes.
 */
export function detectSlotChanges(callback: () => void, hostElement: any): void {
  const slotObserver = (mutationsList) => {
    for (const mutation of mutationsList) {
      if (mutation.type === "childList") {
        callback();
      }
    }
  };
  const observer = new MutationObserver(slotObserver);
  observer.observe(hostElement, { childList: true });
  observer.observe(hostElement.shadowRoot, { childList: true });
}

export function detectMarkupChanges(callback: () => void, hostElement: any): void {
  const slotObserver = (mutationsList) => {
    for (const mutation of mutationsList) {
      if (
        mutation.type === "subtree" ||
        mutation.type === "characterData" ||
        mutation.type === "attributes" ||
        mutation.type === "childList"
      ) {
        callback();
      }
    }
  };
  const observer = new MutationObserver(slotObserver);
  observer.observe(hostElement, { subtree: true, childList: true, characterData: true, attributes: true });
  observer.observe(hostElement.shadowRoot, { subtree: true, childList: true, characterData: true, attributes: true });
}
